import OneGrowScene from './OneGrowScene';

export default OneGrowScene;